/* pg-shop-chat.js: our own customer chat window.
   Markup: snippets/pg-shop-chat.liquid. Look: assets/pg-shop-chat.css.
   Server: POST /a/locations/chat (Shopify app proxy), always HTTP 200 JSON.

   One IIFE, no dependencies, no regex lookbehind, no top-level await.
   Shopify minifies this file itself: do NOT rename it to .min.js.

   Staging (shop metafield chat.mode, read by the snippet):
     on    active for everyone
     test  dormant unless a test key is held (?pgchat=KEY, kept in localStorage
           as pgsc_test; ?pgchat=off clears it). The key goes out as "t".

   Server text is only ever written with textContent / createTextNode. */
(function () {
  'use strict';

  var ENDPOINT = '/a/locations/chat';
  var CONV_KEY = 'pgsc_v1';
  var TEST_KEY = 'pgsc_test';
  var UI_KEY = 'pgsc_ui';
  var LINK_HOST = 'https://puzzlesgalore.co.uk';
  var DAY_MS = 24 * 60 * 60 * 1000;
  var MAX_LEN = 700;
  var COUNT_FROM = 600;
  var POLL_MS = 1200;
  var MAX_POLL_FAILS = 8;
  /* "watch": nothing is being written, but a person may reply. */
  var WATCH_OPEN_MS = 4000;
  var WATCH_CLOSED_MS = 20000;
  var WATCH_MAX_MS = 30 * 60 * 1000;

  var noop = function () {};
  var root = document.getElementById('pgsc-root');
  if (!root) return;
  var MODE = root.getAttribute('data-pgsc-mode');

  /* ── Storage: every access is wrapped, Safari private mode throws ───── */
  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {}
  }
  function ssGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function ssSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }
  function parse(text) {
    try { return JSON.parse(text); } catch (e) { return null; }
  }

  /* ── Test key: read it from the address bar, then take it out ───────── */
  var testKey = null;
  (function readTestKey() {
    var fromUrl;
    var found = false;
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.has('pgchat')) {
        found = true;
        fromUrl = String(params.get('pgchat') || '').slice(0, 200);
        params.delete('pgchat');
        var rest = params.toString();
        window.history.replaceState(
          window.history.state,
          '',
          window.location.pathname + (rest ? '?' + rest : '') + window.location.hash
        );
      }
    } catch (e) {}
    if (found) {
      if (!fromUrl || fromUrl === 'off') { lsSet(TEST_KEY, null); testKey = null; }
      else { lsSet(TEST_KEY, fromUrl); testKey = fromUrl; }
      return;
    }
    testKey = lsGet(TEST_KEY) || null;
  })();

  var active = MODE === 'on' || (MODE === 'test' && !!testKey);
  if (!active) {
    window.PGShopChat = { active: false, open: noop, close: noop };
    return;
  }

  /* Published straight away so pg-chat-launcher can defer to us. open and
     close are function declarations further down (hoisted). */
  window.PGShopChat = { active: true, open: open, close: close };

  var docEl = document.documentElement;
  docEl.classList.add('pgsc-active');

  function $(sel) { return root.querySelector(sel); }
  var launcher = $('[data-pgsc-launcher]');
  var dot = $('[data-pgsc-dot]');
  var panel = $('[data-pgsc-panel]');
  var scroller = $('[data-pgsc-scroll]');
  var log = $('[data-pgsc-log]');
  var typing = $('[data-pgsc-typing]');
  var activity = $('[data-pgsc-activity]');
  var handoff = $('[data-pgsc-handoff]');
  var rateBar = $('[data-pgsc-rate]');
  var rateQ = $('[data-pgsc-rate-q]');
  var notice = $('[data-pgsc-notice]');
  var composer = $('[data-pgsc-composer]');
  var input = $('[data-pgsc-input]');
  var sendBtn = $('[data-pgsc-send]');
  var meta = $('[data-pgsc-meta]');
  var countEl = $('[data-pgsc-count]');
  var remainingEl = $('[data-pgsc-remaining]');
  var humanBtn = $('[data-pgsc-human]');
  var copyBtn = $('[data-pgsc-copy]');      // optional: absent in older markup
  var subEl = $('[data-pgsc-sub]');         // optional: absent in older markup
  var closeBtn = $('[data-pgsc-close]');
  var cardVerify = $('[data-pgsc-card="verify"]');
  var cardCode = $('[data-pgsc-card="verify_code"]');
  var cardContact = $('[data-pgsc-card="contact"]');
  var cardConfirm = $('[data-pgsc-card="confirm"]');   // optional: absent in older markup
  var noteWrap = $('[data-pgsc-note-wrap]');
  if (!launcher || !panel || !log || !input || !composer) {
    /* The markup is not what this script expects: stand down completely and
       give Shopify's own widget back rather than leave no chat at all. */
    window.PGShopChat = { active: false, open: noop, close: noop };
    docEl.classList.remove('pgsc-active');
    var hideRule = document.getElementById('pgsc-hide-inbox');
    if (hideRule && hideRule.parentNode) hideRule.parentNode.removeChild(hideRule);
    return;
  }

  /* ── State ──────────────────────────────────────────────────────────── */
  var st = {
    c: null, k: null, lastId: 0, pending: null,
    canSend: true, remaining: null, ui: null, state: 'open',
    live: false, watch: false, canCopy: false
  };
  /* The two lines the snippet holds for us (all fixed copy lives there). */
  var subText = subEl ? subEl.textContent : '';
  var subLiveText = (subEl && subEl.getAttribute('data-pgsc-sub-live')) || subText;
  var teamLabel = log.getAttribute('data-pgsc-team-label') || 'Puzzles Galore team';
  var rendered = {};        // message id -> true: an id is never drawn twice
  var convGen = 0;          // bumped on reset so late answers are dropped
  var convAt = 0;
  var seenId = 0;           // highest id the customer has had on screen
  var rated = false;
  var hasAssistant = false;
  var handoffSaid = false;  // a server notice has already said customer service replies by email
  var restored = false;     // the stored transcript has been fetched
  var restoreWanted = false;
  var isOpen = false;
  var unread = 0;
  var returnFocus = null;
  var sending = false;
  var locked = false;       // "limit": the conversation is full
  var rateHold = false;     // "rate": sent too fast, waiting out retryInMs
  var rateTimer = null;
  var thanksTimer = null;
  var rateQuestion = rateQ.textContent;
  var forceContact = null;  // { note: boolean } when we show the contact card ourselves
  var uiOverride = null;    // "verify" after "Send a new code"
  var shownCard = null;
  var pollTimer = null;
  var pollBusy = false;
  var pollFails = 0;
  /* Watching for a person's reply. watchFrom is when the 30 minutes last
     started (0 = the server has not asked us to watch); watchTop is the highest
     message id that has already restarted it. Both ride in pgsc_ui so the
     clock carries across pages instead of starting again on each one. */
  var watchFrom = 0;
  var watchTop = 0;
  var copyBusy = false;
  var copyDone = false;     // a copy was emailed: once per page view
  var optimistic = null;
  var maxViewH = 0;

  var phoneQuery = window.matchMedia ? window.matchMedia('(max-width: 599.98px)') : null;
  function isPhone() { return !!(phoneQuery && phoneQuery.matches); }

  /* ── Conversation identity ──────────────────────────────────────────── */
  function loadConv() {
    var o = parse(lsGet(CONV_KEY) || '');
    if (!o || typeof o !== 'object' || !o.c || !o.k || !(Date.now() - Number(o.at) < DAY_MS)) {
      if (o) lsSet(CONV_KEY, null);
      return;
    }
    st.c = String(o.c);
    st.k = String(o.k);
    convAt = Number(o.at);
    seenId = Number(o.s) || 0;
    rated = !!o.r;
  }
  function saveConv() {
    if (!st.c || !st.k) return;
    lsSet(CONV_KEY, JSON.stringify({ c: st.c, k: st.k, at: convAt, s: seenId, r: rated ? 1 : 0 }));
  }
  function touch() {
    convAt = Date.now();
    saveConv();
  }
  function saveUi() {
    ssSet(UI_KEY, JSON.stringify({
      o: isOpen ? 1 : 0, p: st.pending ? 1 : 0, w: watchFrom, m: watchTop
    }));
  }

  function resetConversation() {
    convGen++;
    st.c = null; st.k = null; st.lastId = 0; st.pending = null;
    st.canSend = true; st.remaining = null; st.ui = null; st.state = 'open';
    st.live = false; st.watch = false; st.canCopy = false;
    watchFrom = 0; watchTop = 0;
    copyBusy = false; copyDone = false;
    rendered = {};
    seenId = 0; rated = false; hasAssistant = false; handoffSaid = false;
    restored = true; restoreWanted = false;
    locked = false; forceContact = null; uiOverride = null;
    unread = 0;
    stopPoll();
    pollBusy = false;
    sending = false;
    input.readOnly = false;
    removeOptimistic();
    lsSet(CONV_KEY, null);
    var old = log.querySelectorAll('[data-pgsc-id]');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    /* A new conversation may be rated afresh. */
    if (thanksTimer) { clearTimeout(thanksTimer); thanksTimer = null; }
    rateBar.hidden = true;
    rateQ.textContent = rateQuestion;
    var rb = rateBar.querySelectorAll('[data-pgsc-rate-btn]');
    for (var j = 0; j < rb.length; j++) { rb[j].hidden = false; rb[j].disabled = false; }
    saveUi();
    render();
  }

  /* ── Network ────────────────────────────────────────────────────────── */
  function api(intent, fields) {
    /* "after" rides on every call, not only poll: the server builds the
       snapshot it returns from it, so without it every card action would be
       answered with the whole transcript again. */
    var body = { intent: intent, c: st.c, k: st.k, t: testKey || null, after: st.lastId };
    if (fields) {
      for (var f in fields) {
        if (Object.prototype.hasOwnProperty.call(fields, f)) body[f] = fields[f];
      }
    }
    return window.fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status !== 200) throw new Error('status ' + res.status);
      return res.text();
    }).then(function (text) {
      var json = parse(text);
      if (!json || typeof json !== 'object') throw new Error('not json');
      return json;
    });
  }

  /* Take what a reply carries: new identity, a snapshot, a notice line. */
  function absorb(resp) {
    if (resp.c && resp.k) {
      st.c = String(resp.c);
      st.k = String(resp.k);
      touch();
    }
    if (resp.snapshot && typeof resp.snapshot === 'object') applySnapshot(resp.snapshot);
    if (typeof resp.message === 'string' && resp.message) setNotice(resp.message);
  }

  /* ── Rendering ──────────────────────────────────────────────────────── */
  function safeLink(url) {
    if (url !== LINK_HOST && url.indexOf(LINK_HOST + '/') !== 0) return null;
    try {
      var u = new URL(url);
      if (u.protocol !== 'https:' || u.hostname !== 'puzzlesgalore.co.uk') return null;
      if (u.username || u.password || u.port) return null;
      return u.href;
    } catch (e) {
      return null;
    }
  }
  /* Plain text in, text nodes out. Only our own shop's URLs become links. */
  function fillText(el, text, linkify) {
    text = String(text === null || text === undefined ? '' : text);
    if (!linkify) { el.textContent = text; return; }
    var re = /https?:\/\/[^\s]+/g;
    var last = 0;
    var m;
    while ((m = re.exec(text))) {
      var url = m[0].replace(/[.,;:!?)\]}'"]+$/, '');
      var href = safeLink(url);
      if (!href) continue;
      if (m.index > last) el.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement('a');
      a.className = 'pgsc-a';
      a.href = href;
      a.textContent = url;
      el.appendChild(a);
      last = m.index + url.length;
      re.lastIndex = last;
    }
    if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)));
  }

  function buildMessage(role, text) {
    var row = document.createElement('div');
    row.className = 'pgsc-msg pgsc-msg--' + role;
    var body;
    if (role === 'notice') {
      body = document.createElement('p');
      body.className = 'pgsc-note';
      fillText(body, text, false);
    } else {
      if (role === 'team') {
        /* A person, not the assistant: say so above the bubble. Screen readers
           get the name from the hidden label inside the bubble instead, so it
           is not read twice. */
        var name = document.createElement('span');
        name.className = 'pgsc-who';
        name.setAttribute('aria-hidden', 'true');
        name.textContent = teamLabel;
        row.appendChild(name);
      }
      body = document.createElement('div');
      body.className = 'pgsc-bubble';
      var who = document.createElement('span');
      who.className = 'pgsc-vh';
      who.textContent = role === 'customer' ? 'You: '
        : (role === 'team' ? teamLabel + ': ' : 'Assistant: ');
      body.appendChild(who);
      var span = document.createElement('span');
      fillText(span, text, role !== 'customer');
      body.appendChild(span);
    }
    row.appendChild(body);
    return row;
  }

  function renderMessage(m) {
    if (!m || typeof m !== 'object') return false;
    var id = Number(m.id);
    if (!isFinite(id) || rendered[id]) return false;
    rendered[id] = true;
    /* Anything we do not know is drawn as a plain notice, never as a bubble
       that claims a speaker. */
    var role = m.role === 'customer' || m.role === 'assistant' || m.role === 'team' ? m.role : 'notice';
    var row = buildMessage(role, m.text);
    row.setAttribute('data-pgsc-id', String(id));
    log.appendChild(row);
    if (role === 'assistant') hasAssistant = true;
    /* The server writes its own "gone to customer service" line into the
       conversation. When it has, our fixed line would say it twice. */
    if (role === 'notice' && /by email|to the team|to customer service/i.test(String(m.text || ''))) handoffSaid = true;
    return role;
  }

  function nearBottom() {
    return scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 90;
  }
  function scrollToEnd() {
    scroller.scrollTop = scroller.scrollHeight;
  }

  function applySnapshot(s) {
    var stick = nearBottom();
    var list = Array.isArray(s.messages) ? s.messages.slice() : [];
    list.sort(function (a, b) { return Number(a && a.id) - Number(b && b.id); });
    var fresh = false;   // a message this browser has not counted before
    for (var i = 0; i < list.length; i++) {
      var role = renderMessage(list[i]);
      if (!role) continue;
      var id = Number(list[i].id);
      if (id > st.lastId) st.lastId = id;
      if (id > watchTop) { watchTop = id; fresh = true; }
      if (role === 'customer') stick = true;
      /* Everything the customer did not write themselves is worth the dot. */
      if (role !== 'customer' && !isOpen && id > seenId) unread++;
    }
    var snapLast = Number(s.lastId);
    if (isFinite(snapLast) && snapLast > st.lastId) st.lastId = snapLast;

    st.pending = s.pending && typeof s.pending === 'object' ? s.pending : null;
    st.canSend = s.canSend !== false;
    st.remaining = typeof s.remaining === 'number' ? s.remaining : null;
    st.ui = s.ui === 'verify' || s.ui === 'verify_code' || s.ui === 'contact' || s.ui === 'confirm' ? s.ui : null;
    st.state = typeof s.state === 'string' ? s.state : 'open';
    st.live = s.live === true;
    st.canCopy = s.canCopy === true;
    st.watch = s.watch === true;
    /* The 30 minutes start when the server first asks us to watch and start
       again on every new message. Once they run out watchFrom is left alone
       (stale, not zero), so only a new message can start them again. */
    if (!st.watch) watchFrom = 0;
    else if (fresh || !watchFrom) watchFrom = Date.now();
    if (st.ui !== 'verify_code') uiOverride = null;

    if (isOpen) seenId = st.lastId;
    saveConv();
    saveUi();
    render();
    if (stick) scrollToEnd();
  }

  function setNotice(text) {
    var stick = nearBottom();
    if (text) {
      notice.textContent = text;
      notice.hidden = false;
      if (stick) scrollToEnd();
    } else {
      notice.textContent = '';
      notice.hidden = true;
    }
  }

  function renderUnread() {
    dot.hidden = unread === 0;
    var label = unread > 0
      ? 'Chat with us, ' + unread + ' unread message' + (unread === 1 ? '' : 's')
      : 'Chat with us';
    launcher.setAttribute('aria-label', label);
    var bubbles = document.querySelectorAll('[data-pg-chat-bubble]');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].textContent = unread > 0 ? (unread > 99 ? '99+' : String(unread)) : '';
      bubbles[i].hidden = unread === 0;
    }
    var actions = document.querySelectorAll('.pg-chat-action');
    for (var j = 0; j < actions.length; j++) actions[j].setAttribute('aria-label', label);
  }

  function sendBlocked() {
    return sending || !!st.pending || !st.canSend || locked || rateHold;
  }

  function renderComposer() {
    var off = !st.canSend || locked;
    input.disabled = off;
    sendBtn.disabled = sendBlocked() || input.value.replace(/\s+/g, '') === '';

    var len = input.value.length;
    var showCount = len >= COUNT_FROM;
    countEl.hidden = !showCount;
    if (showCount) {
      countEl.textContent = len + ' / ' + MAX_LEN;
      if (len >= MAX_LEN) countEl.setAttribute('data-pgsc-full', '');
      else countEl.removeAttribute('data-pgsc-full');
    }
    var showLeft = st.remaining !== null && st.remaining <= 3;
    remainingEl.hidden = !showLeft;
    if (showLeft) {
      var n = Math.max(0, st.remaining);
      remainingEl.textContent = n === 0
        ? 'No messages left in this chat'
        : n + ' message' + (n === 1 ? '' : 's') + ' left in this chat';
    }
    meta.hidden = !showCount && !showLeft;
  }

  function currentCard() {
    if (forceContact) return 'contact';
    if (uiOverride && st.ui === 'verify_code') return uiOverride;
    return st.ui;
  }

  function renderCards() {
    var which = currentCard();
    cardVerify.hidden = which !== 'verify';
    cardCode.hidden = which !== 'verify_code';
    cardContact.hidden = which !== 'contact';
    /* The Yes / No buttons under a change to their order. Hidden while a
       reply is being written, so an answer cannot be sent twice. */
    if (cardConfirm) cardConfirm.hidden = which !== 'confirm' || !!st.pending || sending || locked;
    noteWrap.hidden = !(forceContact && forceContact.note);
    if (which !== shownCard) {
      shownCard = which;
      if (which && isOpen) scrollToEnd();
    }
  }

  function render() {
    typing.hidden = !st.pending;
    if (st.pending) {
      var act = typeof st.pending.activity === 'string' ? st.pending.activity : '';
      activity.textContent = act || 'Writing a reply';
    }
    /* "Your message has gone to customer service" is only true once they have
       somewhere to reply to. While the contact card is still asking for an
       address the server's own line says so, and the two together read as a
       contradiction (seen on the first preview, 2026-10-02). Nor is it shown
       while a person is in the chat. */
    handoff.hidden = st.state !== 'handed_off' || handoffSaid || st.ui === 'contact' || st.live;
    /* A person has joined: the header says so, and nobody is asked to rate
       the assistant while they are talking to one. */
    if (subEl) subEl.textContent = st.live ? subLiveText : subText;
    if (st.live) rateBar.hidden = true;
    else if (hasAssistant && !rated) rateBar.hidden = false;
    renderCards();
    renderComposer();
    renderUnread();
    humanBtn.disabled = st.state === 'handed_off';
    if (copyBtn) {
      copyBtn.hidden = !st.canCopy;
      copyBtn.disabled = copyBusy || copyDone;
    }
  }

  function autosize() {
    input.style.height = 'auto';
    input.style.height = Math.min(132, Math.max(44, input.scrollHeight + 2)) + 'px';
  }

  /* ── Polling ──────────────────────────────────────────────────────────
     ONE loop: one timer (pollTimer), one request at a time (pollBusy). It runs
     fast while a reply is being written or a transcript is being fetched, and
     slowly while the server has asked us to watch for a person's reply. There
     is no second loop for watching: only the delay differs. */
  function watching() {
    return st.watch && watchFrom > 0 && Date.now() - watchFrom < WATCH_MAX_MS;
  }
  function needPoll() {
    return !!st.c && (!!st.pending || restoreWanted || watching());
  }
  function pollDelay() {
    if (st.pending || restoreWanted) return POLL_MS;
    return isOpen ? WATCH_OPEN_MS : WATCH_CLOSED_MS;
  }
  function stopPoll() {
    if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
  }
  function schedulePoll(ms) {
    stopPoll();
    if (document.hidden) return;   // resumed by visibilitychange
    pollTimer = setTimeout(doPoll, ms);
  }
  /* Set the next poll for whatever is needed now, or none at all. */
  function queuePoll() {
    if (needPoll()) schedulePoll(pollDelay());
    else stopPoll();
  }
  function doPoll() {
    stopPoll();   // called directly as well as by the timer: never leave one behind
    if (pollBusy || !st.c || document.hidden) return;
    pollBusy = true;
    var gen = convGen;
    var restoring = restoreWanted;
    if (restoring) log.setAttribute('aria-live', 'off');   // do not read a whole transcript aloud
    api('poll', { after: st.lastId }).then(function (r) {
      if (gen !== convGen) return;
      pollBusy = false;
      pollFails = 0;
      if (r.ok) {
        restored = true;
        restoreWanted = false;
        absorb(r);
        if (restoring) {
          scrollToEnd();
          setTimeout(function () { log.setAttribute('aria-live', 'polite'); }, 300);
        }
        queuePoll();
        return;
      }
      if (restoring) log.setAttribute('aria-live', 'polite');
      if (r.code === 'busy') { schedulePoll(POLL_MS); return; }
      if (r.code === 'rate') { schedulePoll(Math.max(POLL_MS, Number(r.retryInMs) || 3000)); return; }
      if (r.code === 'gone') {
        resetConversation();
        setNotice(r.message || 'That chat has ended. Send a message to start a new one.');
        return;
      }
      /* Refused outright: stop asking, including the slow watch, until a
         later answer from the server says to watch again. */
      restoreWanted = false;
      st.pending = null;
      st.watch = false;
      saveUi();
      render();
      if (typeof r.message === 'string' && r.message) setNotice(r.message);
    }, function () {
      if (gen !== convGen) return;
      pollBusy = false;
      if (restoring) log.setAttribute('aria-live', 'polite');
      pollFails++;
      if (pollFails > MAX_POLL_FAILS) {
        pollFails = 0;
        restoreWanted = false;
        st.pending = null;
        saveUi();
        render();
        setNotice('We lost the connection. Close the chat and open it again to carry on.');
        return;
      }
      /* 2s, 4s, 8s, then 15s at most */
      schedulePoll(Math.min(15000, 2000 * Math.pow(2, pollFails - 1)));
    });
  }

  /* ── Sending ────────────────────────────────────────────────────────── */
  function showOptimistic(text) {
    removeOptimistic();
    optimistic = buildMessage('customer', text);
    optimistic.className += ' pgsc-msg--sending';
    log.appendChild(optimistic);
    scrollToEnd();
  }
  function removeOptimistic() {
    if (optimistic && optimistic.parentNode) optimistic.parentNode.removeChild(optimistic);
    optimistic = null;
  }
  function restoreText(text) {
    input.readOnly = false;
    if (!input.value) input.value = text;
    autosize();
  }
  function holdForRate(ms) {
    rateHold = true;
    if (rateTimer) clearTimeout(rateTimer);
    rateTimer = setTimeout(function () {
      rateTimer = null;
      rateHold = false;
      renderComposer();
    }, Math.max(500, Number(ms) || 3000));
  }
  function showContact(withNote, text) {
    forceContact = { note: !!withNote };
    if (withNote && text) {
      var note = cardContact.elements.note;
      if (note && !note.value) note.value = text;
    }
    renderCards();
    scrollToEnd();
  }

  /* The customer's own basket, read from Shopify in THEIR browser when they
     press send, so the assistant can answer "why won't my code work?" without
     handing it to a person (2026-10-21). The server never fetches a basket
     itself. Short fields only, capped, and money stays in minor units. Never
     fails the message: no basket inside 1.5 s, or any error, sends none. */
  function readBasket() {
    if (!window.fetch) return Promise.resolve(undefined);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var timer;
    var late = new Promise(function (resolve) { timer = setTimeout(function () { resolve(undefined); }, 1500); });
    var read = window.fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : undefined; })
      .then(function (c) {
        if (!c || typeof c !== 'object') return undefined;
        var cut = function (s, n) { return String(s == null ? '' : s).slice(0, n); };
        var lines = (c.items || []).slice(0, 25).map(function (l) {
          var d = (l.line_level_discount_allocations || []).slice(0, 3).map(function (a) {
            return { t: cut(a && a.discount_application && a.discount_application.title, 60), a: a && a.amount };
          });
          return { t: cut(l.product_title || l.title, 90), q: l.quantity, p: l.final_price, d: d };
        });
        var deals = (c.cart_level_discount_applications || []).slice(0, 3).map(function (a) {
          return { t: cut(a && a.title, 60), v: cut(a && a.value, 20), k: cut(a && a.value_type, 20) };
        });
        var codes = (c.discount_codes || []).slice(0, 5).map(function (x) {
          return { c: cut(x && x.code, 40), ok: !!(x && x.applicable) };
        });
        return { n: c.item_count, total: c.total_price, cur: cut(c.currency, 3), codes: codes, lines: lines, deals: deals };
      })
      .catch(function () { return undefined; });
    return Promise.race([read, late]).then(function (b) { clearTimeout(timer); return b; });
  }

  function send(text, retried) {
    sending = true;
    setNotice('');
    input.value = '';
    input.readOnly = true;
    autosize();
    showOptimistic(text);
    renderComposer();
    var gen = convGen;
    readBasket().then(function (basket) {
      var fields = { text: text, page: window.location.pathname };
      if (basket !== undefined) fields.basket = basket;
      return api('send', fields);
    }).then(function (r) {
      if (gen !== convGen) return;
      sending = false;
      removeOptimistic();
      if (r.ok) {
        input.readOnly = false;
        restored = true;
        touch();
        absorb(r);
        touch();
        scrollToEnd();
        /* A reply being written is polled for quickly. With a person in the
           chat nothing is pending, so this falls to the slow watch. */
        schedulePoll(needPoll() ? pollDelay() : POLL_MS);
        renderComposer();
        return;
      }
      if (r.code === 'gone' && !retried) {
        resetConversation();
        send(text, true);
        return;
      }
      input.readOnly = false;
      switch (r.code) {
        case 'closed':
          setNotice(r.message || 'Chat is not available right now. Leave a message and customer service will reply by email.');
          showContact(true, text);
          break;
        case 'limit':
          locked = true;
          setNotice(r.message || 'This chat has reached its limit. Leave a message and customer service will reply by email.');
          showContact(true, text);
          break;
        case 'rate':
          restoreText(text);
          setNotice(r.message || 'You are sending messages quickly. Give it a moment and try again.');
          holdForRate(r.retryInMs);
          break;
        case 'busy':
          restoreText(text);
          setNotice(r.message || 'Still writing the last reply. Send this once it arrives.');
          schedulePoll(POLL_MS);
          break;
        case 'too_long':
          restoreText(text);
          setNotice(r.message || 'That message is too long. Please shorten it and send again.');
          break;
        case 'gone':
          restoreText(text);
          setNotice(r.message || 'That chat has ended. Send your message again to start a new one.');
          break;
        case 'test_only':
          restoreText(text);
          setNotice(r.message || 'This chat is being tested and is not open yet.');
          break;
        default:
          restoreText(text);
          setNotice(r.message || 'That did not send. Try again.');
      }
      if (r.snapshot && typeof r.snapshot === 'object') applySnapshot(r.snapshot);
      render();
    }, function () {
      if (gen !== convGen) return;
      sending = false;
      removeOptimistic();
      restoreText(text);
      setNotice('That did not send. Try again.');
      renderComposer();
    });
  }

  function submitComposer() {
    var text = input.value.replace(/^\s+|\s+$/g, '');
    if (!text || sendBlocked()) return;
    if (text.length > MAX_LEN) text = text.slice(0, MAX_LEN);
    send(text, false);
  }

  /* ── Cards and small actions ────────────────────────────────────────── */
  function cardButton(form) { return form.querySelector('button[type="submit"]'); }

  /* Shared shape for verify_start, verify_code, contact, human. */
  function act(intent, fields, button, onOk, onFail) {
    if (button) button.disabled = true;
    setNotice('');
    var gen = convGen;
    api(intent, fields).then(function (r) {
      if (button) button.disabled = false;
      if (gen !== convGen) return;
      if (r.ok) {
        if (onOk) onOk(r);
        absorb(r);
        render();
        if (!r.snapshot && st.c) { restoreWanted = !restored; doPoll(); }
        else queuePoll();
        return;
      }
      if (r.code === 'gone') {
        resetConversation();
        setNotice(r.message || 'That chat has ended. Send a message to start a new one.');
        return;
      }
      if (r.snapshot && typeof r.snapshot === 'object') applySnapshot(r.snapshot);
      setNotice(r.message || 'That did not work. Try again.');
      if (onFail) onFail(r);
    }, function () {
      if (button) button.disabled = false;
      if (gen !== convGen) return;
      render();
      setNotice('That did not send. Try again.');
    });
  }

  function trimmed(el) { return el ? String(el.value || '').replace(/^\s+|\s+$/g, '') : ''; }
  function checkEmail(el) {
    var v = trimmed(el);
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    if (ok) el.removeAttribute('aria-invalid');
    else { el.setAttribute('aria-invalid', 'true'); el.focus(); }
    return ok ? v : null;
  }

  cardVerify.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = checkEmail(cardVerify.elements.email);
    if (!email) { setNotice('Please enter your email address.'); return; }
    act('verify_start', { email: email, orderNumber: trimmed(cardVerify.elements.orderNumber) },
      cardButton(cardVerify), function () {
        uiOverride = null;
        cardCode.elements.code.value = '';
      });
  });

  cardCode.addEventListener('submit', function (e) {
    e.preventDefault();
    var el = cardCode.elements.code;
    var code = String(el.value || '').replace(/\D+/g, '');
    if (code.length !== 6) {
      el.setAttribute('aria-invalid', 'true');
      el.focus();
      setNotice('Please enter the 6-digit code from the email.');
      return;
    }
    el.removeAttribute('aria-invalid');
    act('verify_code', { code: code }, cardButton(cardCode), function () { el.value = ''; }, function () {
      /* A wrong code: empty the box so the next try starts clean. */
      el.value = '';
      if (!cardCode.hidden) el.focus();
    });
  });

  var newCodeBtn = cardCode.querySelector('[data-pgsc-newcode]');
  if (newCodeBtn) {
    newCodeBtn.addEventListener('click', function () {
      uiOverride = 'verify';
      setNotice('');
      renderCards();
      cardVerify.elements.email.focus();
    });
  }

  /* Yes / No to a change to their order: sent as an ordinary message, so the
     answer is in the conversation in their own name and the assistant (and
     the server's check that a yes came AFTER the change was put to them)
     handles it exactly as if they had typed it. */
  if (cardConfirm) {
    cardConfirm.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-pgsc-confirm]') : null;
      /* A hidden card has nothing to answer. Two night-time chats on 28 Oct
         opened with "Yes" then "No" 20 seconds apart, on the homepage, with
         no change ever put to them: something clicking every button in the
         page, hidden or not, and each click cost a reply on the plan. */
      if (!b || cardConfirm.hidden || sendBlocked()) return;
      cardConfirm.hidden = true;
      send(b.getAttribute('data-pgsc-confirm') === 'yes' ? 'Yes, please go ahead' : 'No, leave my order as it is', false);
    });
  }

  cardContact.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = checkEmail(cardContact.elements.email);
    if (!email) { setNotice('Please enter your email address.'); return; }
    var withNote = !!(forceContact && forceContact.note);
    var note = withNote ? trimmed(cardContact.elements.note).slice(0, MAX_LEN) : '';
    act('contact', { email: email, name: trimmed(cardContact.elements.name), note: note },
      cardButton(cardContact), function (r) {
        forceContact = null;
        cardContact.elements.note.value = '';
        /* The server normally says thank you itself, as a message in the
           conversation. Only speak if it said nothing at all. */
        var said = r.message || (r.snapshot && r.snapshot.messages && r.snapshot.messages.length);
        if (!said) setNotice('Thanks. Customer service will reply by email.');
      });
  });

  humanBtn.addEventListener('click', function () {
    /* Nothing to send on yet: collect the message and an email instead. */
    if (!st.c) {
      setNotice('');
      showContact(true, trimmed(input));
      cardContact.elements.email.focus();
      return;
    }
    act('human', {}, humanBtn, null);
  });

  /* "Email me a copy of this chat": only offered once the server says the
     customer is verified (canCopy), and once per page view. Not act(): that
     hands the button back when the call ends, and this one stays spent. */
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      if (!st.c || !st.canCopy || copyBusy || copyDone) return;
      copyBusy = true;
      copyBtn.disabled = true;
      setNotice('');
      var gen = convGen;
      api('copy', {}).then(function (r) {
        if (gen !== convGen) return;
        copyBusy = false;
        if (r.ok) {
          copyDone = true;
          absorb(r);
          if (!(typeof r.message === 'string' && r.message)) setNotice('Sent. Check your email.');
          render();
          scrollToEnd();
          queuePoll();
          return;
        }
        if (r.code === 'gone') {
          resetConversation();
          setNotice(r.message || 'That chat has ended. Send a message to start a new one.');
          return;
        }
        if (r.snapshot && typeof r.snapshot === 'object') applySnapshot(r.snapshot);
        render();
        setNotice(r.message || 'That did not work. Try again.');
        scrollToEnd();
      }, function () {
        if (gen !== convGen) return;
        copyBusy = false;
        render();
        setNotice('That did not send. Try again.');
        scrollToEnd();
      });
    });
  }

  rateBar.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pgsc-rate-btn]') : null;
    if (!btn || rated || !st.c) return;
    var up = btn.getAttribute('data-pgsc-rate-btn') === 'up';
    var buttons = rateBar.querySelectorAll('[data-pgsc-rate-btn]');
    var i;
    for (i = 0; i < buttons.length; i++) buttons[i].disabled = true;
    var gen = convGen;
    function done() {
      rated = true;
      saveConv();
      for (i = 0; i < buttons.length; i++) buttons[i].hidden = true;
      rateQ.textContent = 'Thanks';
      /* Say it, then get out of the way of the conversation. */
      if (thanksTimer) clearTimeout(thanksTimer);
      thanksTimer = setTimeout(function () { thanksTimer = null; rateBar.hidden = true; }, 4000);
    }
    api('rate', { up: up }).then(function (r) {
      if (gen !== convGen) return;
      if (r.ok) { done(); return; }
      if (r.code === 'gone') { resetConversation(); return; }
      done();   // already rated, or refused: either way do not ask again
    }, function () {
      if (gen !== convGen) return;
      for (i = 0; i < buttons.length; i++) buttons[i].disabled = false;
    });
  });

  /* ── Composer events ────────────────────────────────────────────────── */
  input.addEventListener('input', function () {
    if (input.value.length > MAX_LEN) input.value = input.value.slice(0, MAX_LEN);
    autosize();
    renderComposer();
  });
  input.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.shiftKey || e.isComposing || e.keyCode === 229) return;
    e.preventDefault();
    submitComposer();
  });
  composer.addEventListener('submit', function (e) {
    e.preventDefault();
    submitComposer();
  });

  /* ── Viewport: the phone sheet follows the visual viewport ──────────── */
  function syncViewport() {
    if (!isOpen) return;
    var vv = window.visualViewport;
    if (vv && vv.scale > 1.01) return;   // pinch-zoomed: leave the last good size
    var h = vv ? vv.height : window.innerHeight;
    var top = vv ? vv.offsetTop : 0;
    var stick = nearBottom();
    root.style.setProperty('--pgsc-vv-h', Math.round(h) + 'px');
    root.style.setProperty('--pgsc-vv-top', Math.max(0, Math.round(top)) + 'px');
    if (h > maxViewH) maxViewH = h;
    if (isPhone() && h < maxViewH - 120) root.setAttribute('data-pgsc-kb', '');
    else root.removeAttribute('data-pgsc-kb');
    if (isPhone()) docEl.classList.add('pgsc-lock');
    else docEl.classList.remove('pgsc-lock');
    if (stick) scrollToEnd();
  }
  function watchViewport(on) {
    var vv = window.visualViewport;
    var fn = on ? 'addEventListener' : 'removeEventListener';
    if (vv) {
      vv[fn]('resize', syncViewport);
      vv[fn]('scroll', syncViewport);
    }
    window[fn]('resize', syncViewport);
  }

  /* ── Open and close ─────────────────────────────────────────────────── */
  function publish() {
    /* The same attribute pg-chat-launcher publishes for Shopify's widget, so
       the theme smoke test reads one signal whichever chat is live. */
    docEl.setAttribute('data-pg-chat', isOpen ? 'open' : 'closed');
  }

  function open(trigger, quiet) {
    if (isOpen) {
      if (!quiet) focusComposer();
      return;
    }
    isOpen = true;
    returnFocus = trigger && typeof trigger.focus === 'function' ? trigger
      : (quiet ? null : document.activeElement);
    panel.hidden = false;
    root.setAttribute('data-pgsc-open', '');
    launcher.setAttribute('aria-expanded', 'true');
    maxViewH = 0;
    watchViewport(true);
    syncViewport();
    unread = 0;
    seenId = st.lastId;
    saveConv();
    saveUi();
    publish();
    render();
    autosize();
    if (st.c && !restored) {
      restoreWanted = true;
      doPoll();
    } else if (st.pending || restoreWanted) {
      if (!pollTimer) doPoll();
    } else if (st.c && st.watch) {
      /* A person may have replied while the window was shut: look now rather
         than at the end of a 20 second wait, and move to the faster open
         pace. Once the 30 minutes have run out this is the one look an open
         gets; a new message is what starts the watch again. */
      doPoll();
    }
    scrollToEnd();
    if (!quiet) focusComposer();
  }

  function focusComposer() {
    var target = input.disabled ? panel : input;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    panel.hidden = true;
    root.removeAttribute('data-pgsc-open');
    root.removeAttribute('data-pgsc-kb');
    launcher.setAttribute('aria-expanded', 'false');
    docEl.classList.remove('pgsc-lock');
    watchViewport(false);
    seenId = st.lastId;
    saveConv();
    saveUi();
    publish();
    queuePoll();   // the watch drops to its closed pace; a pending reply keeps its own
    var back = returnFocus;
    returnFocus = null;
    /* A trigger inside a drawer that has since closed cannot take focus. */
    if (!back || !back.isConnected || back === document.body || !back.getClientRects().length) back = launcher;
    try { back.focus({ preventScroll: true }); } catch (e) { try { back.focus(); } catch (e2) {} }
  }

  launcher.addEventListener('click', function () {
    if (isOpen) close();
    else open(launcher);
  });
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    var inside = panel.contains(e.target) || e.target === launcher;
    if ((e.key === 'Escape' || e.key === 'Esc') && (inside || e.target === document.body)) {
      e.preventDefault();
      close();
      return;
    }
    /* The phone sheet covers the whole page, so Tab stays inside it. */
    if (e.key === 'Tab' && inside && isPhone()) {
      var nodes = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled])');
      var list = [];
      for (var i = 0; i < nodes.length; i++) if (nodes[i].getClientRects().length) list.push(nodes[i]);
      if (!list.length) return;
      var first = list[0];
      var lastEl = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  if (phoneQuery) {
    var onBreak = function () { syncViewport(); };
    if (phoneQuery.addEventListener) phoneQuery.addEventListener('change', onBreak);
    else if (phoneQuery.addListener) phoneQuery.addListener(onBreak);
  }

  /* ── Tab visibility: no timers in a hidden tab, none left behind ────── */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopPoll(); return; }
    if (needPoll() && !pollBusy && !pollTimer) doPoll();
  });
  window.addEventListener('pagehide', function () {
    stopPoll();
    if (rateTimer) { clearTimeout(rateTimer); rateTimer = null; rateHold = false; }
    if (thanksTimer) { clearTimeout(thanksTimer); thanksTimer = null; rateBar.hidden = true; }
    saveUi();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && needPoll() && !pollBusy && !pollTimer) doPoll();
  });

  /* ── Start ──────────────────────────────────────────────────────────── */
  loadConv();
  restored = !st.c;
  root.hidden = false;
  publish();
  render();

  var ui = parse(ssGet(UI_KEY) || '') || {};
  if (st.c) {
    /* Carry the watch clock over from the last page (see watchFrom above). */
    watchFrom = Number(ui.w) > 0 ? Number(ui.w) : 0;
    watchTop = Number(ui.m) > 0 ? Number(ui.m) : 0;
  }
  var queued = window.PGShopChatQueue;
  window.PGShopChatQueue = null;
  if (queued) {
    /* A trigger was pressed before this deferred script had run. */
    open(queued === true ? null : queued);
  } else if (st.c && ui.o && !isPhone()) {
    /* The window was open on the last page: keep it open on a desktop, where
       it sits beside the page. A phone sheet would cover the page just opened. */
    open(null, true);
  } else if (st.c && (ui.p || (watchFrom > 0 && Date.now() - watchFrom < WATCH_MAX_MS))) {
    /* A reply was still being written when the page changed, or we were
       watching for a person's reply: fetch it quietly so the unread dot can
       show. The answer says whether to keep watching. */
    restoreWanted = true;
    doPoll();
  }
})();
